var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty-box"},[_c('img',{staticClass:"empty-img",attrs:{"src":_vm.emptyImg}})])}
var staticRenderFns = []

export { render, staticRenderFns }